import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import HomePage from './homepage';
import { fetchResearchLinks } from '../../redux/shared/shared.actions';
import { authdata, get, getConfig } from '../../helpers';
import keyPageIds from '../../utilities/key-pages';
import APIManager from '../../utilities/api-manager';

const numberOfSolutions = getConfig('numberOfSolutions');
const Window = window as AnonymousObject;
Window.dataLayer = Window.dataLayer || [];

const mapStateToProps = (state: RootStoreState): HomePageProps => {
    const featuredDatasets = get(state, 'filters.featuredDatasets', []) as DatasetFeaturedAlternative[];
    const alternativeData = get(state, 'filters.alternativeDatasets', []) as DatasetFeaturedAlternative[];
    let solutions = get(state, 'solutions.all.response', []) as APISolution[];
    const userEmail = state && state.user && state.user.userInfo ? state.user.userInfo.Email : '';
    const keyOnlineUserId = state.user && state.user.userInfo && state.user.userInfo.KeyOnlineUser ? state.user.userInfo.KeyOnlineUser : '';
    solutions = authdata(solutions, userEmail);
    const researchData = get(state, 'shared.researchLinks.data', []) as ResearchLinkItem[];
    const pageTextsData = get(state, 'shared.pageSections.data', []) as PageSections[];
    const featuredBPData = get(state, 'filters.featuredBlueprints', []) as BlueprintsFeatured[];


    let keyOnlineUserCompanyType = get(state, 'user.userInfo.KeyOnlineUserCompanyType', undefined);

    // non mi users keyOnlineUserCompanyType is -1
    if (keyOnlineUserCompanyType !== undefined && keyOnlineUserCompanyType === -1) keyOnlineUserCompanyType = undefined;

    // // push login event to GA
    // const isPushed = sessionStorage.getItem('isLoginEventPushed');
    // if ((isPushed === null || (isPushed && isPushed.trim().length === 0))) {
    //     console.log(' push login event to GA 1', isPushed);
    //     if (keyOnlineUserId && keyOnlineUserId.length > 0) {
    //         console.log(' push login event to GA 2', keyOnlineUserId);
    //         sessionStorage.setItem('isLoginEventPushed', 'true');
    //         Window.dataLayer.push({
    //             event: 'login',
    //             keyOnlineUser: keyOnlineUserId
    //         });
    //     }
    // }

    return {
        researchData,
        solutions: solutions.filter(solution => solution.FormOrderHomepageSolution).sort((a, b) => a.FormOrderHomepageSolution - b.FormOrderHomepageSolution).slice(0, numberOfSolutions),
        isLoggedIn: get(state, 'user.isLoggedIn', false),
        keyOnlineUserCompanyType,
        alternativeData: alternativeData.sort((a, b) => a.FormOrder - b.FormOrder).map(dataset => {
            if (dataset.KeyMarketplaceDataset) return dataset.KeyMarketplaceDataset;
            if (dataset.KeyMarketplaceDatasetBundle) return dataset.KeyMarketplaceDatasetBundle;
            return 0;
        }),
        featuredData: featuredDatasets.sort((a, b) => a.FormOrder - b.FormOrder).map(dataset => {
            if (dataset.KeyMarketplaceDataset) return dataset.KeyMarketplaceDataset;
            if (dataset.KeyMarketplaceDatasetBundle) return dataset.KeyMarketplaceDatasetBundle;
            return 0;
        }),
        pageTextsData: pageTextsData.filter(x => x.KeyOnlinePage === keyPageIds.homePage || x.KeyOnlinePage === keyPageIds.homeResultsPage),
        featuredBlueprintData: featuredBPData.map(blueprint => {
            return blueprint.KeyMarketplaceBlueprint;
        })
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): HomePageActions => ({
    fetchResearchLinks: () => {
        dispatch(fetchResearchLinks());
    },
});


export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
